<template>
    <div class="projectBody">
        <div class="width_total_100 headerBg projectTopBg animateContent projectAnimate1">
            <div class="w_container">
                <div class="commonTop">
                    <OmpLink></OmpLink>
                </div>
                <div class="bannerPart">
                    <div>
                        <div>深度挖掘数据潜在价值</div>
                        <p>一键快速产生可视化图表</p>
                    </div>
                    <FreeTryButton @getFreeTryVisible="getVisible"></FreeTryButton>
                </div>
            </div>
        </div>
        <div class="width_total_100 animateContent projectAnimate2" style="margin-top:-710px;">
            <div class="w_container">
                <div class="instruction">
                    <div class="instruTitle">
                        <div>功能亮点</div>
                        <p>Functional highlights</p>
                    </div>
                    <div class="proHightLights">
                        <ul>
                            <li>
                                <img src="../assets/img/projectFea_01.png" />
                                <p>资料更新自动上传，及时更新</p>
                            </li>
                            <li>
                                <img src="../assets/img/projectFea_02.png" />
                                <p>支持图内筛选，多角度查看数据</p>
                            </li>
                            <li>
                                <img src="../assets/img/projectFea_03.png" />
                                <p>串联ERP报表，免对账</p>
                            </li>
                            <li>
                                <img src="../assets/img/projectFea_04.png" />
                                <p>支持多资料来源（EXCEL、指标、报表、SQL等）</p>
                            </li>
                            <li>
                                <img src="../assets/img/projectFea_05.png" />
                                <p>不需具有编程功底，即可制作图表</p>
                            </li>
                            <li>
                                <img src="../assets/img/projectFea_06.png" />
                                <p>用户权限灵活管控，保证资讯安全</p>
                            </li>
                            <li>
                                <img src="../assets/img/projectFea_07.png" />
                                <p>一键快速生成酷炫图表，专业可靠</p>
                            </li>
                            <li>
                                <img src="../assets/img/projectFea_08.png" />
                                <p>多报表关联，数据无需汇入汇出</p>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        <div class="width_total_100">
            <div class="w_container">
                <div class="prjCharacters">
                    <div class="instruTitle proMakeTitle">
                        <div>产品特色</div>
                        <p>Product Characteristics</p>
                    </div>
                    <div class="proCharacterCon">
                        <el-carousel trigger="click" :autoplay="false" height="610px">
                            <el-carousel-item>
                                <div class="prjCharaSlideCon clearfix">
                                    <img src="https://escloud.digiwincloud.com/static/zh-CN/img/projectFea_09.gif" />
                                    <div class="prjCharaSlideCon_font">
                                        <div>极简操作，拖曳完成</div>
                                        <p>简单拖曳即可生成数据报表，无须求助于程序员或数据分析师，不会SQL、EXCEL照样搞定数据处理。</p>
                                    </div>
                                </div>
                            </el-carousel-item>
                            <el-carousel-item>
                                <div class="prjCharaSlideCon clearfix">
                                    <img src="https://escloud.digiwincloud.com/static/zh-CN/img/projectFea_10.gif" />
                                    <div class="prjCharaSlideCon_font">
                                        <div>明细查询，快速定位</div>
                                        <p>提供多维度的数据图表呈现，支持异常数据的明细查询，可快速发现问题根源，制定应对方案。</p>
                                    </div>
                                </div>
                            </el-carousel-item>
                            <el-carousel-item>
                                <div class="prjCharaSlideCon clearfix">
                                    <img src="https://escloud.digiwincloud.com/static/zh-CN/img/projectFea_11.gif" />
                                    <div class="prjCharaSlideCon_font">
                                        <div>异常数据，智能预警</div>
                                        <p>事先设定数据警戒线，一旦发生异常情况，将第一时间发送消息通知，降低企业犯错成本。</p>
                                    </div>
                                </div>
                            </el-carousel-item>
                            <el-carousel-item>
                                <div class="prjCharaSlideCon clearfix">
                                    <img src="https://escloud.digiwincloud.com/static/zh-CN/img/projectFea_12.gif" />
                                    <div class="prjCharaSlideCon_font">
                                        <div>关联数据，自动更新</div>
                                        <p>对接ERP报表或指标，图表随原始数据实时更新，无须手工修改，显著提升数据处理效率，减少人工成本。</p>
                                    </div>
                                </div>
                            </el-carousel-item>
                        </el-carousel>
                    </div>
                </div>
            </div>
        </div>
        <div class="width_total_100 animateContent projectAnimate3">
            <div class="w_container">
                <div class="projectTec">
                    <div class="instruTitle proMakeTitle projectTecTitle">
                        <div>技术可靠，保障安全</div>
                        <p>Product Pricing</p>
                    </div>
                    <div class="projectTecCon">
                        <ul class="clearfix">
                            <li class="projTeLi1">
                                <em>架构</em>
                                <div class="projectTecConPer">
                                    <p>基于微软云平台Microsoft Azure的混合云架构</p>
                                    <!-- <div class="proLine"></div>
                                    <p>数据服务器可部署在企业本地</p>
                                    <div class="proLine"></div>
                                    <p>应用服务器可选上云或本地部署</p> -->
                                    <div class="proLine"></div>
                                    <p>支持大规模全域服务所需的云端基础架构</p>
                                </div>
                            </li>
                            <li class="projTeLi2">
                                <em>数据</em>
                                <div class="projectTecConPer">
                                    <p>采用进阶加密标准 AES 128bits 进行档案加密</p>
                                    <div class="proLine"></div>
                                    <p>精细化的用户角色权限管控，用户行为可全程追踪，防止泄密。</p>
                                    <div class="proLine"></div>
                                    <p>利用凭证(Certificate Pinning) 绑定方式，防止中间人（MITM）攻击传输中资料。</p>
                                    <div class="proLine"></div>
                                    <p>采取高可用（HA）措施，可自动、定时备份，杜绝资料遗失风险。</p>
                                </div>
                            </li>
                            <li class="projTeLi3">
                                <em>应用</em>
                                <div class="projectTecConPer">
                                    <p>加密隧道与云端接入</p>
                                    <div class="proLine"></div>
                                    <p>企业身份认证及权限控制</p>
                                    <div class="proLine"></div>
                                    <p>监控账号登录密码及时间，限制非法登录尝试。</p>
                                    <div class="proLine"></div>
                                    <p>采用 https 协定代替 http协定，SSL/TLS 加密传输资讯，防止篡改/窃听/截取。</p>
                                </div>
                            </li>
                            <li class="projTeLi4">
                                <em>平台</em>
                                <div class="projectTecConPer">
                                    <p>采用符合业界通讯协定的 OAuth 2进行云端平台身份验证及授权</p>
                                    <div class="proLine"></div>
                                    <p>符合物理安全性和可用性的行业标准，如 ISO 27001等。</p>
                                    <div class="proLine"></div>
                                    <p>服务可用性>99.99%</p>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        <div class="width_total_100 proBottomBg animateContent projectAnimate4">
            <div class="w_container">
                <div class="projectChange">
                    <div class="instruTitle quickTitle animateTitle">
                        <div>使用Tip Biu BI，可以为您带来哪些改变？</div>
                        <p>What changes can you make by using graphical reports?</p>
                    </div>
                    <div class="projectChangeCon">
                        <div class="proChangePer">
                            <div class="proChangePerCon">
                                <img src="https://escloud.digiwincloud.com/static/zh-CN/img/project_before.png" />
                                <ul>
                                    <li>1. 数据图表制作过程复杂、重覆、漫长，无法实时更新变动数据，影响决策效率。</li>
                                    <li>2. 报表数据来源多且繁杂，无法直接抓取关键数据，及时发现风险问题。</li>
                                    <li>3. 一般使用Excel制作图表，报表的及时性、美观度、专业性、安全性等体验感较差。</li>
                                    <li>4. 跨部门开会无重点、无结果，管理者难以现场展现有说服力的数据图表供决策者参考，一个项目难以多方合作推进。</li>
                                </ul>
                            </div>
                        </div>
                        <div class="proChangePer">
                            <div class="proChangePerCon">
                                <img src="https://escloud.digiwincloud.com/static/zh-CN/img/project_now.png" />
                                <ul>
                                    <li>1. 快速、自动抓取ERP系统数据，按时更新数据信息，避免人工重覆稽核。</li>
                                    <li>2. 多维度、图形化呈现数据图表，满足阅读者不同角度的数据需求，辅助商业决策。</li>
                                    <li>3. 支持移动跨屏，随时随地接收企业数据资讯，更快决策。</li>
                                    <li>4. 一键产生数据图表，根据使用者权限可随时随地查阅，跨部合作更容易!</li>
                                </ul>
                            </div>
                        </div>
                        <div class="projFreeTry">
                            <FreeTryButton @getFreeTryVisible="getVisible"></FreeTryButton>
                        </div>
                        <div class="clear"></div>
                        <div style="margin-top:130px;">
                            <Footer></Footer>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <Control></Control>
        <FreeTry :visible.sync="freeTryVisible"></FreeTry>
    </div>
</template>
<script>
    import "@/assets/css/w-style.css"

    import OmpLink from "@/components/common/OmpLink.vue"
    import Control from "@/components/common/Control.vue"
    import Footer from "@/components/common/Footer.vue"
    import FreeTryButton from "@/components/common/FreeTryButton.vue"
    import FreeTry from "@/components/common/FreeTry.vue"

  export default {
    components: {
        OmpLink,
        Control,
        Footer,
        FreeTryButton,
        FreeTry
    },
    name: 'Project',
    data() {
      return {
        freeTryVisible: false
      }
    },
    created () {
        this.$http.post('/backend/web/record', {
            pageName: 'Project',
            contentName : '',
            extend2: 'CN',
        }, {headers: { "Content-Type": "application/json" }})
        .then(function (response) {
            if(response.status == 200){
                console.log("success");
            }
        })
        .catch(function (error) {
            console.log(error);
        });
    },
    mounted() {
        this.projectTopAnimate() // 顶部动画
        this.projectScrollAnimate() // 滚动动画
    },
    methods: {
        projectTopAnimate() {
            var projectAnimate_show1=1,projectAnimate_show2=1
            $(".projectBody").children(".animateContent").each(function() {
            if($(this).hasClass("projectAnimate1") &&  parseInt(projectAnimate_show1)){
                projectAnimate_show1 = 0;
                $(this).find(".bannerPart").delay(800).addClass('animated fadeInUp');
            }else if($(this).hasClass("projectAnimate2") &&  parseInt(projectAnimate_show2)){
                projectAnimate_show2 = 0;
                $(this).find(".proHightLights ul li").delay(800).addClass('flipInX animated hinge3');
                $(this).find(".proHightLights ul li").stop().animate({"opacity":"1"},400);
            } 
	     });
        },
        projectScrollAnimate() {
            $(window).scroll(function(){
                var projectAnimate_show3=1,projectAnimate_show4=1;
                var scrollTop = window.pageYOffset||document.documentElement.scrollTop||document.body.scrollTop|| 0;
                $(".projectBody").children(".animateContent").each(function() {
                    var srollh = $(this).offset().top-$(window).height()+$(this).height()/3;
                    if((scrollTop > srollh)){
                        if($(this).hasClass("projectAnimate3") &&  parseInt(projectAnimate_show3)){
                            projectAnimate_show3 = 0;
                            $(this).find(".projTeLi1").stop().animate({"opacity":"1"},400);
                            $(this).find(".projTeLi2").stop().delay(300).animate({"opacity":"1"},400);
                            $(this).find(".projTeLi3").stop().delay(600).animate({"opacity":"1"},400);
                            $(this).find(".projTeLi4").stop().delay(900).animate({"opacity":"1"},400);
                        } else if($(this).hasClass("projectAnimate4") &&  parseInt(projectAnimate_show4)){
                            projectAnimate_show4 = 0;
                            $(this).find(".animateTitle").delay(800).addClass('animated bounceIn');
                            $(this).find(".proChangePer:nth-child(1)").delay(800).addClass('animated bounceIn');
                            $(this).find(".proChangePer:nth-child(2)").delay(800).addClass('animated bounceIn');
                            $(this).find(".projFreeTry").delay(800).addClass('animated bounceIn');
                            $(this).find(".proChangePer").stop().animate({"opacity":"1"},400);
                            $(this).find(".animateTitle").stop().animate({"opacity":"1"},400);
                            $(this).find(".projFreeTry").stop().animate({"opacity":"1"},400);
                        }	
                    }
                });
            });
        },
        getVisible(visible) {
            this.freeTryVisible = visible
        }
    }
  }
</script>
<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/Project.vue